import { render, staticRenderFns } from "./ERTCFile.vue?vue&type=template&id=010eb7d0&scoped=true&"
import script from "./ERTCFile.vue?vue&type=script&lang=js&"
export * from "./ERTCFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010eb7d0",
  null
  
)

export default component.exports